/*eslint-disable*/
import React, { Fragment, useState, useEffect, useContext } from "react";
import Table from "../../components/table/Table";
import AuthContext from "../../auth/context";
import api from "../../services/api";
import AppContext from "../../container/context";
import mes from "../../enums/mes";
import { formatDateTime } from "../../helpers/helpers";

import ArticleIcon from "@mui/icons-material/Article";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
  Divider,
} from "@mui/material";

const dataAtual = new Date();

const Boletos = ({ history }) => {
  const [carregando, setCarregando] = useState(true);
  const [faturas, setFaturas] = useState([]);
  const { notification } = useContext(AppContext);
  const usuario = useContext(AuthContext);

  useEffect(() => {
    listarFaturas();
  }, []);

  const listarFaturas = () => {
    api
      .get("faturas/painelControleEscola")
      .then((faturas) => {
        if (faturas.length > 0) {
          faturas.forEach((item) => {
            item.referencia = `${item.mes}/${item.ano}`;
            item.valor = (item.valor / 100).toFixed(2);

            if (item.faturaId) {
              item.vencimento = item.vencimento
                ? `${formatDateTime(item.vencimento, "D/M/Y")}`
                : "-";
              item.linkFatura = (
                <a href={item.faturaLinkIugu} target="_blank">
                  {item.faturaLinkIugu}
                </a>
              );
              item.pagamento = item.faturaPagamento ? "Ok" : "Não registrado";
              item.cor = item.faturaPagamento
                ? "#bcffb8"
                : new Date(item.vencimento) < dataAtual
                ? "#ffbf94"
                : "#ffffff";
            } else {
              if (
                item.mes === dataAtual.getMonth() &&
                item.ano === dataAtual.getFullYear()
              ) {
                item.msgGeracaoFatura =
                  "A fatura já pode ser gerada." + dataAtual.getMonth();
              } else {
                item.msgGeracaoFatura = `A fatura poderá ser gerada a partir de 1/${item.mes}/${item.ano}.`;
              }
            }
          });

          setFaturas(faturas);
        } else {
          setFaturas([]);
        }

        setCarregando(false);
      })
      .catch((e) => notification("error", `Erro ao listar as faturas:  ${e}`));
  };

  const gerarFatura = (escolaFatura) => {
    setCarregando(true);

    const dadosFatura = {
      mes: escolaFatura.mes,
      ano: escolaFatura.ano,
    };

    api
      .put("faturas/faturarEscola", dadosFatura)
      .then((faturaGerada) => {
        setCarregando(false);

        if (faturaGerada.id) {
          notification("success", "Fatura gerada com sucesso!");
          return listarFaturas();
        }
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            return notification("error", "Período inválido");
          case 2:
            return notification("error", "Sem pagamentos para faturar");
          case 3:
            return notification(
              "error",
              "Já existe fatura ativa para o período"
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const sincronizarIugu = (faturaEscola) => {
    notification("warning", "Iniciando sincronização, por favor aguarde.");

    api
      .post("faturas/sincronizarIugu", { faturaId: faturaEscola.faturaId })
      .then((res) => {
        notification("warning", "Sincronização concluída.");

        switch (res.status) {
          case 0:
            notification("warning", "Sem informações.");

          case 1:
            notification("warning", "Pagamento pendente.");

            break;
          case 2:
            notification("success", "Pagamento confirmado!");

            return listarFaturas();
          case 3:
            notification("warning", "Fatura cancelada.");

            break;
          case 4:
            notification("warning", "Fatura suspensa.");

            break;
          default:
            notification("warning", "Fatura suspensa.");
        }
      })
      .catch((err) => {
        const { data } = err.response;
        switch (data[0]) {
          case 1:
            return notification(
              "error",
              "A IUGU não retornou informações da fatura"
            );

          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const gerarNovaFatura = (faturaEscola) => {
    notification(
      "warning",
      "Verificando situação da fatura atual, por favor aguarde."
    );

    api
      .post("faturas/sincronizarIugu", { faturaId: faturaEscola.faturaId })
      .then((res) => {
        notification("warning", "Sincronização concluída.");

        switch (res.status) {
          case 1:
            notification(
              "warning",
              "A fatura atual ainda está disponível para pagamento."
            );

            break;
          case 2:
            notification("success", "Pagamento confirmado!");

            return listarFaturas();
          default:
            notification("warning", "Cancelando fatura atual.");
            api
              .post("faturas/cancelar", { faturaId: faturaEscola.faturaId })
              .then(() => {
                notification("warning", "Fatura cancelada.");
                gerarFatura(faturaEscola);
              })
              .catch((err) => {
                const { data } = err.response;
                switch (data[0]) {
                  case 1:
                    return notification(
                      "error",
                      "A IUGU não retornou informações da fatura"
                    );

                  default:
                    return notification("error", "Dados inválidos");
                }
              });
        }
      })
      .catch((e) => {
        console.log(e);
        notification("error", "Erro ao cancelar a fatura.");
      });
  };

  return (
    <>
      {carregando ? (
        <CircularProgress />
      ) : (
        <Grid container>
          {faturas.map((fatura) => (
            <Grid item md={12}>
              <Card style={{ marginBottom: 10, backgroundColor: fatura.cor }}>
                <CardContent>
                  <Typography variant="h5" component="p">
                    {fatura.referencia}
                  </Typography>
                  <br />
                  <b>Valor: </b> R$ {fatura.valor}
                  <br />
                  {fatura.faturaId ? (
                    <>
                      <b>Link da fatura (IUGU): </b> {fatura.linkFatura}
                      <br />
                      <b>Vencimento: </b> {fatura.vencimento}
                      <br />
                      <b>Pagamento: </b> {fatura.pagamento}
                      <br />
                    </>
                  ) : (
                    <p>{fatura.msgGeracaoFatura}</p>
                  )}
                </CardContent>
                <CardActions>
                  <Button
                    variant="outlined"
                    // color="default"
                    size="medium"
                    onClick={() =>
                      history.push(
                        `/app/boletos/fatura/${fatura.ano}/${fatura.mes}`
                      )
                    }
                    // startIcon={<ArticleIcon></ArticleIcon>}
                  >
                    <ArticleIcon></ArticleIcon>
                    Detalhes da fatura
                  </Button>
                  {fatura.faturaId
                    ? !fatura.faturaPagamento && (
                        <Button
                          variant="outlined"
                          // color="default"
                          size="medium"
                          onClick={() => sincronizarIugu(fatura)}
                        >
                          <RefreshIcon></RefreshIcon>
                          Sincronizar com IUGU
                        </Button>
                      )
                    : fatura.mes === dataAtual.getMonth() &&
                      fatura.ano === dataAtual.getFullYear() && (
                        <Button
                          variant="contained"
                          color="primary"
                          size="medium"
                          onClick={() => gerarFatura(fatura)}
                        >
                          <ArrowCircleDownIcon></ArrowCircleDownIcon>
                          Gerar fatura
                        </Button>
                      )}
                  {fatura.vencimento &&
                    new Date(fatura.vencimento) < dataAtual && (
                      <Button
                        variant="contained"
                        color="secondary"
                        size="medium"
                        onClick={() => gerarNovaFatura(fatura)}
                        startIcon={
                          <i className="zmdi zmdi-smartphone-download"></i>
                        }
                      >
                        Gerar nova fatura
                      </Button>
                    )}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default Boletos;

const montarTabelaFaturas = (faturas) => {
  const registros = [];

  faturas.forEach((item) => {
    registros.push([
      <b>
        <p>{item.referencia}</p>
      </b>,
      <p>{item.valor}</p>,
      item.linkFatura,
      <p>{item.vencimento}</p>,
      <p>{item.pagamento}</p>,
      <p>{item.acoes}</p>,
    ]);
  });

  return registros;
};
